import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import QuotationComponent from "../../../components/QuotationComponent";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import QuotationResponseComponent from "../../../components/QuotationResponseComponent";

class Quotation extends React.Component {

    constructor(props) {
        super(props);

        this.registrationId = this.props.customer.registrationId;

        this.state = {
            quotationResponse: null,
            showQuotationResponseModal: false
        }
    }

    retrieveQuotationResponse = (quotationRequest, quotationResponse) => {

        this.setState({
            quotationResponse: quotationResponse,
            showQuotationResponseModal: true
        })
    };

    render() {
        return <Fragment>

            {this.props.isMobile ? this.renderQuotation("mobile") : this.renderQuotation("browser")}

        </Fragment>
    }

    renderQuotation(className) {

        return <Fragment>

            {this.renderQuotationResponseModal(className)}

            <QuotationComponent
                className={className}
                returnQuotationResponse={this.retrieveQuotationResponse}
                setHeader={() => this.props.setHeader("Current Rate")}
                continueLoading={false}
                registrationId={this.registrationId}
            />

        </Fragment>
    }

    renderQuotationResponseModal(className) {

        return <Modal isOpen={this.state.showQuotationResponseModal}>

            <ModalHeader className={className + "_modal_header"}>Current Rate</ModalHeader>
            <ModalBody>
                <QuotationResponseComponent
                    className={className}
                    quotationResponse={this.state.quotationResponse}
                    setHeader={() => this.props.setHeader("Current Rate")}
                />
            </ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({showQuotationResponseModal: false})}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }
}

export default withRouter(Quotation);